import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

// ── Learning Management (/learning) ───────────────────────────────────
export const learningApi = {
  // courses + builder
  listCourses: (params) => api.get('/learning/courses', { params }).then(unwrap),
  getCourse: (id) => api.get(`/learning/courses/${id}`).then(unwrap),
  createCourse: (payload) => api.post('/learning/courses', payload).then(unwrap),
  updateCourse: (id, patch) => api.patch(`/learning/courses/${id}`, patch).then(unwrap),
  deleteCourse: (id) => api.delete(`/learning/courses/${id}`).then(unwrap),
  listLessons: (courseId) => api.get(`/learning/courses/${courseId}/lessons`).then(unwrap),
  addLesson: (courseId, payload) => api.post(`/learning/courses/${courseId}/lessons`, payload).then(unwrap),
  updateLesson: (id, patch) => api.patch(`/learning/lessons/${id}`, patch).then(unwrap),
  removeLesson: (id) => api.delete(`/learning/lessons/${id}`).then(unwrap),
  getAssessment: (courseId) => api.get(`/learning/courses/${courseId}/assessment`).then(unwrap),
  upsertAssessment: (courseId, payload) => api.post(`/learning/courses/${courseId}/assessment`, payload).then(unwrap),
  updateAssessment: (id, patch) => api.patch(`/learning/assessments/${id}`, patch).then(unwrap),

  // learning paths
  listPaths: () => api.get('/learning/paths').then(unwrap),
  getPath: (id) => api.get(`/learning/paths/${id}`).then(unwrap),
  createPath: (payload) => api.post('/learning/paths', payload).then(unwrap),
  updatePath: (id, patch) => api.patch(`/learning/paths/${id}`, patch).then(unwrap),
  deletePath: (id) => api.delete(`/learning/paths/${id}`).then(unwrap),
  addPathCourse: (id, payload) => api.post(`/learning/paths/${id}/courses`, payload).then(unwrap),
  removePathCourse: (id) => api.delete(`/learning/path-courses/${id}`).then(unwrap),

  // enrollments (self-service)
  listEnrollments: (params) => api.get('/learning/enrollments', { params }).then(unwrap),
  getEnrollment: (id) => api.get(`/learning/enrollments/${id}`).then(unwrap),
  enroll: (payload) => api.post('/learning/enrollments', payload).then(unwrap),
  updateProgress: (id, payload) => api.put(`/learning/enrollments/${id}/progress`, payload).then(unwrap),
  complete: (id, payload) => api.post(`/learning/enrollments/${id}/complete`, payload).then(unwrap),

  // certifications
  listCertifications: (params) => api.get('/learning/certifications', { params }).then(unwrap),
  expiringCertifications: (days) => api.get('/learning/certifications/expiring', { params: { days } }).then(unwrap),
  revokeCertification: (id) => api.put(`/learning/certifications/${id}/revoke`).then(unwrap),

  // compliance
  assignCompliance: (payload) => api.post('/learning/compliance/assign', payload).then(unwrap),
  complianceDashboard: (params) => api.get('/learning/compliance', { params }).then(unwrap),
  overdueCompliance: () => api.get('/learning/compliance/overdue').then(unwrap),
};
